// extracted by mini-css-extract-plugin
export default {"root":"_18un0","color-green":"_3dwfM","colorGreen":"_3dwfM","color-red":"_26q2K","colorRed":"_26q2K"};